import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '~/@api/client/authStore'
import { GoogleIcon } from '~/@mid_ui/icons/GoogleIcon'
import { useLoginWithGoogle } from './useLoginWithGoogle'
import { Spinner } from '~/shadcn/ui/spinner'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { useSettings } from '~/@mid_settings/settings'
import { FormError } from '~/@mid_ui-form/form-error/FormError'
import { Button } from '~/shadcn/ui/button/button'
import { useAmbassadorCode } from '~/@biz_ambassador/code/useAmbassadorCode'

function LoginWithGoogleButtonInner() {
  const { setAuthToken } = useAuthStore()
  const navigate = useNavigate()

  const { ambassadorCode, removeAmbassadorCode } = useAmbassadorCode()

  const { loginWithGoogle, isRequesting, error } = useLoginWithGoogle({
    onSuccess: (auth) => {
      removeAmbassadorCode()
      setAuthToken(auth)
      navigate('/')
    },
    ambassadorCode,
  })

  return (
    <>
      <Button
        variant="outline"
        type="button"
        onClick={loginWithGoogle}
        disabled={isRequesting}
        size="2xl"
        className="w-full">
        <GoogleIcon className="w-6.5! h-6.5!" />
        {isRequesting ? (
          <>
            Prihlasujem cez Google... <Spinner className="size-6" />
          </>
        ) : (
          <>Prihlásenie cez Google</>
        )}
      </Button>
      {error && <FormError error={error} />}
    </>
  )
}

function LoginWithGoogleButton() {
  const { googleApi } = useSettings()
  if (!googleApi.clientId) {
    console.warn(
      'Google Client ID is not configured. Google login will not work.'
    )
    return null
  }

  return (
    <GoogleOAuthProvider clientId={googleApi.clientId}>
      <LoginWithGoogleButtonInner />
    </GoogleOAuthProvider>
  )
}

export { LoginWithGoogleButton }
